import { patternEmail } from './../../../core/models/pattern';
import { AuthService } from './../../../core/services/auth-service/auth.service';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  emailSended,
  invalidMailPassword,
  invalidVerificationCode,
  noAccountMail,
  serverError,
} from './../../../core/models/messages';

import { ToastrService } from 'ngx-toastr';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-code-reset',
  templateUrl: './code-reset.component.html',
  styleUrls: ['./code-reset.component.css'],
})
export class CodeResetComponent implements OnInit {
  /* formGroup */
  generateCodeForm: FormGroup = this.codeForm();
  entrepriseEmail!: string;
  loadSpinner: boolean = false;
  userEmail!: string;
  emailControl = new FormControl();

  isResendDisabled = false;
  countdown = 15;
  countdownSubscription?: Subscription;
  
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private reCaptchaService: ReCaptchaService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.entrepriseEmail = params.params['email'];
      },
    });

    this.emailControl.addValidators([
      Validators.required,
      Validators.email,
      Validators.pattern(patternEmail),
    ]);
  }
  /* create code from */
  codeForm() {
    return this.formBuilder.group({
      number1: ['', Validators.required],
      number2: ['', Validators.required],
      number3: ['', Validators.required],
      number4: ['', Validators.required],
    });
  }
  /* send code  */
  reinitiate() {
    if (this.generateCodeForm.valid) {
      this.reCaptchaService.executeAction('resetCode').then(token => {
        this.loadSpinner = true;
        this.spinner.show();
        let codeReset = Object.values(this.generateCodeForm.value).join('');
        this.authService
          .restCode({ code: codeReset, email: this.entrepriseEmail, recaptchaToken: token })
          .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.loadSpinner = false;
              this.spinner.hide();
              this.toastr.success(emailSended);
              this.router.navigate(['auth/reset-password', { token: res?.data }]);
            }
          },

          error: () => {
            this.generateCodeForm.reset()
            this.loadSpinner = false;
            this.spinner.hide();
            this.toastr.error(invalidVerificationCode);
          },
        });

        }).catch(err => {
      this.loadSpinner = false
      this.spinner.hide();
      this.toastr.error('reCAPTCHA verification failed. Please try again.');
    });
    }
  }
  /* sending mail to get reset link */
  resendCodeVerification() {

    if (this.isResendDisabled) return;

    if (this.emailControl.valid) {

      this.reCaptchaService.executeAction('resetCode').then(token => {
      this.spinner.show();
      let data = {
        email: this.entrepriseEmail,
        recaptchaToken: token
      };
      this.loadSpinner = true;
      this.authService
        .resetMail(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res: { status: number; data: any }) => {
            if (res.status == 200) {
              this.generateCodeForm.reset()
              this.loadSpinner = false;
              this.spinner.hide();
              this.toastr.success(emailSended);
              
              this.isResendDisabled = true;
              this.countdown = 15;
              this.countdownSubscription = interval(1000).subscribe(() => {
                if (this.countdown > 0) {
                  this.countdown--;
                } else {
                  this.isResendDisabled = false;
                  this.countdownSubscription?.unsubscribe();
                }
              });
            }
          },
          error: (err: any) => {
            this.loadSpinner = false;
            this.spinner.hide();
            if (err.error.status == 409) {
              this.toastr.error(noAccountMail);
            } else if (err.error.status == 404)
              this.toastr.error(invalidMailPassword);
            else this.toastr.error(serverError);
          },
        });
    }
      ).catch(err => {
        this.loadSpinner = false
        this.spinner.hide();
        this.toastr.error('reCAPTCHA verification failed. Please try again.');
      });
    }
  }
}
